import styled from "styled-components";

const COLORS = {
  BUY: {
    background: "#F2FBF4",
    border: "#C5EDCE",
    text: "#276E38",
  },
  SELL: {
    background: "#FCF5F4",
    border: "#F6D5D2",
    text: "#A23B33",
  },
  DEFAULT: {
    background: "#F9FAF9",
    border: "#D1D3D4",
    text: "#414651",
  },
};

export const Badge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid;

  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  text-transform: capitalize;
  width: fit-content;

  background-color: ${(props) => {
    const type = (props.$type || "").toUpperCase();
    return COLORS[type]?.background || COLORS.DEFAULT.background;
  }};

  border-color: ${(props) => {
    const type = (props.$type || "").toUpperCase();
    return COLORS[type]?.border || COLORS.DEFAULT.border;
  }};

  color: ${(props) => {
    const type = (props.$type || "").toUpperCase();
    return COLORS[type]?.text || COLORS.DEFAULT.text;
  }};
`;
